'use strict';

var jsUtils = require('@swiggy-private/js-utils');

const getAddonVariantString = (addons = [], variants = []) => {
    const addonNames = addons.flatMap((addon) => addon.choices.map((choice) => choice.name));
    const variantNames = variants.flatMap((variantGroup) => variantGroup.variations.map((variation) => variation.name));
    return [...addonNames, ...variantNames].join(", ");
};
function priceInRupee(value, dontFormatPrice) {
    return Math.round(value / 100);
}
const isItemCustomisable = (addons = [], variants = []) => {
    return !jsUtils.isEmpty(addons) || !jsUtils.isEmpty(variants);
};

exports.getAddonVariantString = getAddonVariantString;
exports.isItemCustomisable = isItemCustomisable;
exports.priceInRupee = priceInRupee;
//# sourceMappingURL=helpers-BjcsXRdQ.js.map
